var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CheckmarkVoid",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-checkmark-void","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <circle cx="124.6" cy="125.4" r="117.6" fill="#FFFFFF" className="dibsvg-checkmark-void-background"/>
  <polygon points="105.4,170.6 61.7,127.3 74.3,114.5 105.9,145.7 182.6,75.5 194.7,88.8" className="dibsvg-checkmark-void-check"/>
  <path d="M125 0C56.1 0 0 56.1 0 125s56.1 125 125 125 125-56.1 125-125S193.9 0 125 0zM9 125c0-33 13.8-62.8 36-83.9l154.9 172.4C179.7 230.7 153.5 241 125 241 61 241 9 189 9 125zm197.5 82.4L51.7 35.1C71.7 18.8 97.2 9 125 9c64 0 116 52 116 116 0 32.2-13.2 61.4-34.5 82.4z" className="dibsvg-checkmark-void-void"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/checkmark-void.svg